import { render, staticRenderFns } from "./bannerswipt.vue?vue&type=template&id=6125bc5d&scoped=true&"
import script from "./bannerswipt.vue?vue&type=script&lang=js&"
export * from "./bannerswipt.vue?vue&type=script&lang=js&"
import style0 from "./bannerswipt.vue?vue&type=style&index=0&id=6125bc5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125bc5d",
  null
  
)

export default component.exports